import { Component, OnDestroy } from '@angular/core';

@Component({
    selector: 'pr-alive',
    template: '',
    standalone: false
})
export class PrAliveComponent implements OnDestroy {
  alive: boolean = true;

  ngOnDestroy(): void {
    this.alive = false;
  }
}
